
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Injector, Input, OnInit, ViewChild, WritableSignal, computed, effect, model, runInInjectionContext, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { interval } from 'rxjs';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzCardComponent } from 'ng-zorro-antd/card';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { NzEmptyComponent } from 'ng-zorro-antd/empty';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzStatisticComponent } from 'ng-zorro-antd/statistic';
import { FikoYTKartComponent } from '../../../../fikoyt-kart/fikoyt-kart.component';
import { ParametrelerComponent } from '../../../../parametreler/parametreler.component';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { ServisUyarService } from '@/src/app/uygulamalar/uyar-dokum/servis-uyar.service';
import { IAcılırKutuParametre, IParametre, tumHatalariniAl } from '@/src/service/fikoyt-ui/interfaces/IParametre/IParametre';
import { FikoYTId } from '@/src/service/fikoyt-ui/helpers/FikoYTId';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { IKart, IKartTuru, IUyarVT, IUyarYollar, IVT, IYollar } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';


@Component({
  selector: 'fikoyt-uyar-teklif-olustur',
  templateUrl: './.component.html',
  styleUrls: ['./.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    RouterModule,
    NzLayoutModule,
    NzGridModule,
    ParametrelerComponent,
    NzButtonComponent,
    NzWaveModule,
    NzIconModule
  ]
})
export class TeklifOlusturComponent extends FikoYTKokBilesenComponent {
  @ViewChild('parametrelerBilesen') paramComponent!: ParametrelerComponent;
  /** */

  rota = model("ana-sayfa");

  /** */
  ekleIstek: FikoYTIstekKok;

  teklifParametreler: IParametre[] = [
    {
      ismi: "firma",
      baslik: "Firma",
      altAciklama: "Telifi Yapacağınız Firmayı seçiniz",
      turu: "Açılır Kutu",
      yerTutucu: "Firma",
      ayarlar: {
        solSimge: "🏭",
        arama: true,
        silme: true,
        secenekItm: `return { value: scnk._id, label: scnk.parametreler?.[1]?.degeri }`,
        fapiAyarlar: {
          vt: "FikoYT.Uyar.firmalar",
          yol: "FikoYT.Uyar.firmalar.kalem",
          pipeFunc: `
            return [{
              $match: { parametreler: { $elemMatch: { ismi: "ismi", degeri: { $regex: deger ?? "", $options: "i" } } } },
            }]
          `
        },
        olaylar: {
          secimSilindi: `prm.yetkili=null;`,
          degisti: `prm.yetkili=null;`
        }
      },


    } as IAcılırKutuParametre,
    {
      ismi: "yetkili",
      baslik: "Teklif Yapılan Yetkili",
      altAciklama: "Telifi Yapacağınız Firma Yetkilisini seçiniz",
      turu: "Açılır Kutu",
      yerTutucu: "Firma Yetklisi",
      ayarlar: {
        solSimge: "👷‍♀️", silme: true, arama: true,
        secenekItm: `
          let parametreler = new Proxy({}, {
              get(_, prop: string) {
                return scnk.parametreler?.find(p => p.ismi === prop)?.degeri ?? null;
              }
            });

        return { value: scnk._id, label: (parametreler.ismi ?? '') + ' ' + (parametreler.soyismi ?? '') }`,
        fapiAyarlar: {
          vt: "FikoYT.Uyar.firmalar.personeller" as IUyarVT,
          yol: "FikoYT.Uyar.firmalar.personeller.kalem" as IUyarYollar,
          pipeFunc: `
            return [
                    {
                      "$match": {
                        "parametreler": {
                          "$elemMatch": {
                            "ismi": "firma",
                            "degeri": prm.firma ?? "aaa"
                          }
                        }
                      }
                    },
                    {
                      "$addFields": {
                        "tamAd": {
                          "$concat": [
                            {
                              "$arrayElemAt": [
                                {
                                  "$map": {
                                    "input": {
                                      "$filter": {
                                        "input": "$parametreler",
                                        "as": "p",
                                        "cond": {
                                          "$eq": [
                                            "$$p.ismi",
                                            "ismi"
                                          ]
                                        }
                                      }
                                    },
                                    "as": "p",
                                    "in": "$$p.degeri"
                                  }
                                },
                                0
                              ]
                            },
                            " ",
                            {
                              "$arrayElemAt": [
                                {
                                  "$map": {
                                    "input": {
                                      "$filter": {
                                        "input": "$parametreler",
                                        "as": "p",
                                        "cond": {
                                          "$eq": [
                                            "$$p.ismi",
                                            "soyismi"
                                          ]
                                        }
                                      }
                                    },
                                    "as": "p",
                                    "in": "$$p.degeri"
                                  }
                                },
                                0
                              ]
                            }
                          ]
                        }
                      }
                    },
                    {
                      "$match": {
                        "$or": [
                          {
                            "parametreler": {
                              "$elemMatch": {
                                "ismi": "ismi",
                                "degeri": {
                                  "$regex":
                                    deger ??
                                    "",
                                  "$options": "i"
                                }
                              }
                            }
                          },
                          {
                            "parametreler": {
                              "$elemMatch": {
                                "ismi": "soyismi",
                                "degeri": {
                                  "$regex":
                                    deger ??
                                    "",
                                  "$options": "i"
                                }
                              }
                            }
                          },
                          {
                            "tamAd": {
                              "$regex":
                                deger ??
                                "",
                              "$options": "i"
                            }
                          }
                        ]
                      }
                    }
                  ]
          `
        }
      }
    } as IAcılırKutuParametre,

    {
      ismi: "eposta_referans",
      baslik: "E-Posta Referansı",
      altAciklama: "Telifi aldığınız mailin referansını seçiniz",
      turu: "Açılır Kutu",
      yerTutucu: "E-Posta Referansı",
      ayarlar: {
        solSimge: "📨"
      }
    },

    {
      baslik: "Geçerlilik Tarihi",
      ismi: "gecerlilikTarihi",
      altAciklama: "Telifin geçerlilik tarihini seçiniz",
      turu: "Tarih Saat",
      yerTutucu: "Geçerlilik Tarihi",
      ayarlar: {
        solSimge: "📅",
        format: "dd.MM.yyyy hh:mm:ss 'Hft.'w"
      }
    },

    {
      turu: "Yazı Alanı",
      ismi: "aciklama",
      altAciklama: "Açıklama Giriniz",
      yerTutucu: "Açıklama",
      baslik: "Açıklama",
      degeri: null,

      ayarlar: {
        solSimge: "🖋",
      },
      kontroller: [
      ],
      // uyarilar: [
      //   {
      //     renk: "teal", mesaj:"Teklifle ilgili detayları yazmanız daha sonra hatırlamanıza yardımcı olacak."}
      // ]
    },
  ];


  constructor(public servisUyar: ServisUyarService) {
    super();

    this.ekleIstek = new FikoYTIstekKok({
      metod: 'POST',
      komut: `FikoYT.sistem.DB.hareketler.ekle`,
      onEkOlsun: true,
      // parametreler: { id: 123 },
      depoModu: false,
      oncelik: 0,
      gecikmeliCevap: true,
      gecikmeliCevapSuresi: 500,

    }).onHata(({ self, hatalar }) => {
      this.nzNotification.error("Hatalar Var", hatalar.map(hata => hata.mesaj).join("\n"));
    }).onTamamlandi(({ self }) => {
      this.CD.detectChanges();
    });
  }


  override ngOnDestroy() {
    super.ngOnDestroy();
  }


  override async ngAfterViewInit() {
    super.ngAfterViewInit();


  }



  async formuGonder() {


    return;
    let kalem: IKart = {
      turu: IKartTuru.UYAR_DOKUM,
      vt: "FikoYT.sistem.hareketler",
      yol: "FikoYT.sistem.hareketler.kalem",
      sahip: this.FikoYT.kimlik.aktifKullaniciJson()._id,
      tarih: new Date(),
      parametreler: this.paramComponent.parametreler,
      uygulama: ["Uyar Döküm"],
      veri: this.paramComponent.toJson(),
    }

    this.ekleIstek.parametreler = kalem;

    let cevap: any = await this.ekleIstek.isteSync();

    if (cevap.cevap.sonuc) {
      this.CD.detectChanges();
      this.nzNotification.success("Başarılı", `${this.paramComponent.toJson()?.ismi} adlı firmanın kaydı güncellendi`);
    }
    else {
      this.nzNotification.error("Hata", `${this.paramComponent.toJson()?.ismi} adlı firma güncellenemedi`);
    }
  }
}
